import { render, staticRenderFns } from "./BillsReprint.vue?vue&type=template&id=2155259c&"
import script from "./BillsReprint.vue?vue&type=script&lang=js&"
export * from "./BillsReprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports